<template>
    <div>
        <ul class="invoice-ul">
            <li class="invoice-ul-li"><p>发票抬头：<span>{{danwei.fptaitou}}</span></p></li>
            <li><p>开具类型：<span>{{danwei.fpkjlx}}</span></p></li>
            <li class="invoice-ul-li"><p>发票类型：<span>{{danwei.fplx}}</span></p></li>
            <li v-if="danwei.fpkjlx != '个人'"><p>税务登记证号: <span>{{danwei.fpswdj}}</span></p></li>
            <li v-if="danwei.fpkjlx != '个人'" class="invoice-ul-li"><p>基本开户银行名称：<span>{{danwei.fpkhh}}</span></p></li>
            <li v-if="danwei.fpkjlx != '个人'"><p>基本开户账号：<span>{{danwei.fpkhzh}}</span></p></li>
            <li v-if="danwei.fpkjlx != '个人'" class="invoice-ul-li"><p>注册场所地址：<span>{{danwei.fpzcdz}}</span></p></li>
            <li v-if="danwei.fpkjlx != '个人'"><p>注册固定电话: <span>{{danwei.fpgddh}}</span></p></li>
        </ul>
        <el-button type="primary" @click="editFormVisible =true;  editForm= danwei;">修改发票信息</el-button>

        <!--编辑界面-->
        <el-dialog title="编辑" center :visible.sync="editFormVisible" :close-on-click-modal="false"
                   :before-close="editFormClose">
            <el-form :model="editForm" label-width="180px" class="demo-ruleForm" :rules="editFormRules" ref="editForm">

                <el-form-item label="开具类型" prop="fpkjlx">
                    <el-radio-group v-model="editForm.fpkjlx">
                        <el-radio border label="个人"></el-radio>
                        <el-radio border label="企业"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发票抬头" prop="fptaitou">
                    <el-input v-model="editForm.fptaitou" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="发票类型" prop="fplx">
                    <el-radio-group v-model="editForm.fplx">
                        <el-radio border label="企业增值税普通发票"></el-radio>
                        <el-radio border label="增值税专用发票"></el-radio>
                        <el-radio border label="组织增值税普通发票"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="editForm.fpkjlx != '个人'" label="税务登记证号" prop="fpswdj">
                    <el-input v-model="editForm.fpswdj" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.fpkjlx != '个人'" label="基本开户银行名称" prop="fpkhh">
                    <el-input v-model="editForm.fpkhh" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.fpkjlx != '个人'" label="基本开户账号" prop="fpkhzh">
                    <el-input v-model="editForm.fpkhzh" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.fpkjlx != '个人'" label="注册场所地址" prop="fpzcdz">
                    <el-input v-model="editForm.fpzcdz" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.fpkjlx != '个人'" label="注册固定电话" prop="fpgddh">
                    <el-input v-model="editForm.fpgddh" auto-complete="off"></el-input>
                </el-form-item>
                <!--<el-button type="primary">提交</el-button>-->
                <el-form-item>
                    <el-button type="primary" @click="editSubmit()">保存</el-button>
                    <el-button @click="editFormVisible = false;editForm={}">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        components: {axios},
        name: "invoicemanagement",
        data() {
            return {//编辑相关数据
                editFormVisible: false,//编辑界面是否显示
                editForm: {},
                editFormRules: {
                    fpkjlx: [
                        // {required: true, message: '请选择开具类型', trigger: 'blur'},
                        {required: true, message: '请选择开具类型', trigger: 'blur'}
                    ],
                    fptaitou: [
                        {required: true, message: '请输入发票抬头', trigger: 'blur'},
                        {min: 5, max: 100, message: '请输入正确的发票抬头', trigger: 'blur'}
                    ],
                    fplx: [
                        {required: true, message: '请选择发票类型', trigger: 'blur'},
                    ],
                    fpswdj: [
                        {required: true, message: '请填写税务登记证号', trigger: 'blur'},
                        {min: 7, max: 30, message: '请填写正确的税务登记证号', trigger: 'blur'}
                    ],
                    fpkhh: [
                        {required: true, message: '基本开户银行名称', trigger: 'blur'},
                        {min: 4, max: 30, message: '请正确填写基本开户银行名称', trigger: 'blur'}
                    ],
                    fpkhzh: [
                        {required: true, max: 30, message: '基本开户账号', trigger: 'blur'},
                        {min: 5, message: '请正确填写基本开户账号', trigger: 'blur'}
                    ],
                    fpzcdz: [
                        {required: true, max: 100, message: '注册场所地址', trigger: 'blur'},
                        {min: 5, message: '请正确填写注册场所地址', trigger: 'blur'}
                    ],
                    fpgddh: [
                        {required: true, message: '注册固定电话', trigger: 'blur'},
                        {min: 7, max: 18, message: '请正确填写注册固定电话', trigger: 'blur'}
                    ],
                },
                danwei: {},
            }
        },
        methods: {
            getQiyedata() {
                axios.post("/Api/admin/getQiyedata").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.danwei = res.data.data;
                        } else if (res.data.errcode == 4000) {
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先登入！',
                                type: 'error',
                                duration: 10000
                            });
                            this.$router.push({
                                name: 'Cart',
                            });
                        }
                    }
                });
            },
            //编辑
            editSubmit: function () {
                let that = this;
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        let para = Object.assign({}, this.editForm);
                        axios.post("/Api/admin/UpQiyedata", para).then(result => {
                            if (result.statusText == "OK") {
                                if (result.data.errcode == 0) {
                                    that.$message.success({
                                        showClose: true,
                                        message: '修改成功',
                                        type: 'success',
                                        duration: 5000
                                    });
                                    that.$refs['editForm'].resetFields();
                                    that.editFormVisible = false;
                                    that.getQiyedata();
                                } else if (result.data.errcode == 4000) {
                                    //请先登入
                                    that.$message({
                                        showClose: true,
                                        message: '请先登入！',
                                        type: 'error',
                                        duration: 10000
                                    });
                                    that.$router.push({
                                        name: 'Cart',
                                    });
                                } else {
                                    that.$message.error({
                                        showClose: true,
                                        message: result.data.message,
                                        type: 'error',
                                        duration: 10000
                                    });
                                }
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: "修改失败",
                                    type: 'error',
                                    duration: 5000
                                });
                            }
                        });
                    }
                });
            },
            //关闭编辑
            editFormClose() {
                this.editFormVisible = false;
                this.editForm = {};
            },
        },
        mounted() {
            //获取企业开票信息
            this.getQiyedata();

        },
    }
</script>

<style>
    .invoice-ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .invoice-ul li {
        display: block;
        letter-spacing: 0;
        padding: 0;
        color: #73777A;
        padding-left: 30px;
        border-top: 0;
    }

    .invoice-ul li p {
        height: 44px;
        line-height: 44px;
        margin: 0;
    }

    .invoice-ul li p span {
        color: #19001D;
    }

    .invoice-ul-li {
        background-color: #fff;
    }
</style>